import React from 'react';

export interface ISearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const SearchInput = React.forwardRef<HTMLInputElement, ISearchInputProps>((props, ref) => {
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        (window as any).dataLayer &&
            (window as any).dataLayer.push({
                event: 'event-to-ga',
                eventCategory: 'FilterMenu',
                eventAction: 'blur',
                eventLabel: e.target.value,
            });

        if (props.onBlur) {
            props.onBlur(e);
        }
    };

    return <input type="text" placeholder="Что вы ищете?" className="search-input" {...props} onBlur={handleBlur} ref={ref} />;
});

export default SearchInput;
